export var RegimeScope;
(function (RegimeScope) {
    RegimeScope["market"] = "market";
    RegimeScope["entity"] = "entity";
    RegimeScope["relative"] = "relative";
})(RegimeScope || (RegimeScope = {}));
export var RegimeClassifierType;
(function (RegimeClassifierType) {
    RegimeClassifierType["deterministic"] = "deterministic";
    RegimeClassifierType["hmm"] = "hmm";
    RegimeClassifierType["hybrid"] = "hybrid";
    RegimeClassifierType["walkForward"] = "walkForward";
})(RegimeClassifierType || (RegimeClassifierType = {}));
export var RegimeModelStatus;
(function (RegimeModelStatus) {
    RegimeModelStatus["draft"] = "draft";
    RegimeModelStatus["active"] = "active";
    RegimeModelStatus["retired"] = "retired";
})(RegimeModelStatus || (RegimeModelStatus = {}));
export var MarketTrendState;
(function (MarketTrendState) {
    MarketTrendState["bull"] = "bull";
    MarketTrendState["bear"] = "bear";
    MarketTrendState["range"] = "range";
    MarketTrendState["transition"] = "transition";
})(MarketTrendState || (MarketTrendState = {}));
export var MarketVolatilityState;
(function (MarketVolatilityState) {
    MarketVolatilityState["compressed"] = "compressed";
    MarketVolatilityState["normal"] = "normal";
    MarketVolatilityState["expanding"] = "expanding";
    MarketVolatilityState["stressed"] = "stressed";
})(MarketVolatilityState || (MarketVolatilityState = {}));
export var MarketBreadthState;
(function (MarketBreadthState) {
    MarketBreadthState["broad"] = "broad";
    MarketBreadthState["narrow"] = "narrow";
    MarketBreadthState["weak"] = "weak";
})(MarketBreadthState || (MarketBreadthState = {}));
export var MarketRiskState;
(function (MarketRiskState) {
    MarketRiskState["riskOn"] = "riskOn";
    MarketRiskState["neutral"] = "neutral";
    MarketRiskState["riskOff"] = "riskOff";
})(MarketRiskState || (MarketRiskState = {}));
export var MarketLiquidityState;
(function (MarketLiquidityState) {
    MarketLiquidityState["normal"] = "normal";
    MarketLiquidityState["impaired"] = "impaired";
})(MarketLiquidityState || (MarketLiquidityState = {}));
export var MarketEventState;
(function (MarketEventState) {
    MarketEventState["none"] = "none";
    MarketEventState["macroWindow"] = "macroWindow";
    MarketEventState["opexWindow"] = "opexWindow";
    MarketEventState["earningsPeak"] = "earningsPeak";
})(MarketEventState || (MarketEventState = {}));
export var MarketBenchmarkAgreement;
(function (MarketBenchmarkAgreement) {
    MarketBenchmarkAgreement["spyQqqAlignedBull"] = "spyQqqAlignedBull";
    MarketBenchmarkAgreement["spyQqqAlignedBear"] = "spyQqqAlignedBear";
    MarketBenchmarkAgreement["spyQqqDivergent"] = "spyQqqDivergent";
    MarketBenchmarkAgreement["spyLeading"] = "spyLeading";
    MarketBenchmarkAgreement["qqqLeading"] = "qqqLeading";
})(MarketBenchmarkAgreement || (MarketBenchmarkAgreement = {}));
export var RegimeTransitionState;
(function (RegimeTransitionState) {
    RegimeTransitionState["stable"] = "stable";
    RegimeTransitionState["improving"] = "improving";
    RegimeTransitionState["deteriorating"] = "deteriorating";
    RegimeTransitionState["freshFlip"] = "freshFlip";
})(RegimeTransitionState || (RegimeTransitionState = {}));
export var MarketCompositeState;
(function (MarketCompositeState) {
    MarketCompositeState["bullOrderly"] = "bullOrderly";
    MarketCompositeState["bullFragile"] = "bullFragile";
    MarketCompositeState["rangeCompressed"] = "rangeCompressed";
    MarketCompositeState["rangeRotational"] = "rangeRotational";
    MarketCompositeState["bearOrderly"] = "bearOrderly";
    MarketCompositeState["bearStressed"] = "bearStressed";
    MarketCompositeState["panic"] = "panic";
    MarketCompositeState["recovery"] = "recovery";
    MarketCompositeState["breakdown"] = "breakdown";
    MarketCompositeState["mixedDivergence"] = "mixedDivergence";
})(MarketCompositeState || (MarketCompositeState = {}));
export var EntityTrendState;
(function (EntityTrendState) {
    EntityTrendState["strongUp"] = "strongUp";
    EntityTrendState["up"] = "up";
    EntityTrendState["range"] = "range";
    EntityTrendState["down"] = "down";
    EntityTrendState["strongDown"] = "strongDown";
})(EntityTrendState || (EntityTrendState = {}));
export var EntityVolatilityState;
(function (EntityVolatilityState) {
    EntityVolatilityState["compressed"] = "compressed";
    EntityVolatilityState["calmTrend"] = "calmTrend";
    EntityVolatilityState["calmRange"] = "calmRange";
    EntityVolatilityState["normal"] = "normal";
    EntityVolatilityState["volatileTrend"] = "volatileTrend";
    EntityVolatilityState["volatileRange"] = "volatileRange";
    EntityVolatilityState["shock"] = "shock";
})(EntityVolatilityState || (EntityVolatilityState = {}));
export var EntityLeadershipState;
(function (EntityLeadershipState) {
    EntityLeadershipState["leading"] = "leading";
    EntityLeadershipState["confirming"] = "confirming";
    EntityLeadershipState["lagging"] = "lagging";
    EntityLeadershipState["divergent"] = "divergent";
})(EntityLeadershipState || (EntityLeadershipState = {}));
export var EntityLiquidityState;
(function (EntityLiquidityState) {
    EntityLiquidityState["institutional"] = "institutional";
    EntityLiquidityState["liquid"] = "liquid";
    EntityLiquidityState["thin"] = "thin";
    EntityLiquidityState["dislocated"] = "dislocated";
})(EntityLiquidityState || (EntityLiquidityState = {}));
export var EntityEventState;
(function (EntityEventState) {
    EntityEventState["none"] = "none";
    EntityEventState["preEarnings"] = "preEarnings";
    EntityEventState["postEarnings"] = "postEarnings";
    EntityEventState["catalystShock"] = "catalystShock";
})(EntityEventState || (EntityEventState = {}));
export var EntityStructureState;
(function (EntityStructureState) {
    EntityStructureState["trendPullback"] = "trendPullback";
    EntityStructureState["trendExtension"] = "trendExtension";
    EntityStructureState["rangeCompression"] = "rangeCompression";
    EntityStructureState["rangeExpansion"] = "rangeExpansion";
    EntityStructureState["capitulation"] = "capitulation";
    EntityStructureState["repair"] = "repair";
})(EntityStructureState || (EntityStructureState = {}));
export var EntityCompositeState;
(function (EntityCompositeState) {
    EntityCompositeState["trendBreakout"] = "trendBreakout";
    EntityCompositeState["trendPullback"] = "trendPullback";
    EntityCompositeState["rangeCompression"] = "rangeCompression";
    EntityCompositeState["rangeExpansion"] = "rangeExpansion";
    EntityCompositeState["meanReversion"] = "meanReversion";
    EntityCompositeState["capitulation"] = "capitulation";
    EntityCompositeState["recovering"] = "recovering";
    EntityCompositeState["brokenTrend"] = "brokenTrend";
})(EntityCompositeState || (EntityCompositeState = {}));
export var RelativeTrendState;
(function (RelativeTrendState) {
    RelativeTrendState["outperforming"] = "outperforming";
    RelativeTrendState["inline"] = "inline";
    RelativeTrendState["underperforming"] = "underperforming";
})(RelativeTrendState || (RelativeTrendState = {}));
export var RelativeMomentumState;
(function (RelativeMomentumState) {
    RelativeMomentumState["accelerating"] = "accelerating";
    RelativeMomentumState["steady"] = "steady";
    RelativeMomentumState["fading"] = "fading";
})(RelativeMomentumState || (RelativeMomentumState = {}));
export var BetaAdjustedLeadershipState;
(function (BetaAdjustedLeadershipState) {
    BetaAdjustedLeadershipState["leader"] = "leader";
    BetaAdjustedLeadershipState["neutral"] = "neutral";
    BetaAdjustedLeadershipState["laggard"] = "laggard";
})(BetaAdjustedLeadershipState || (BetaAdjustedLeadershipState = {}));
export var CorrelationState;
(function (CorrelationState) {
    CorrelationState["highlyCorrelated"] = "highlyCorrelated";
    CorrelationState["moderatelyCorrelated"] = "moderatelyCorrelated";
    CorrelationState["idiosyncratic"] = "idiosyncratic";
})(CorrelationState || (CorrelationState = {}));
//# sourceMappingURL=RegimeTypes.js.map